export enum ENUM_ROUTES {
  DASHBOARD = "/dashboard",

  // Customers
  MANAGE_CUSTOMERS = "/manage-customers",
  ADD_CUSTOMER = "/manage-customers/add",
  CUSTOMER_DETAIL = "/manage-customers/detail",

  // Maintenance Team
  MANAGE_MAINTENANCE_TEAM = "/manage-maintenance-team",
  ADD_MAINTENANCE_TEAM = "/manage-maintenance-team/add",
  MAINTENANCE_TEAM_DETAIL = "/manage-maintenance-team/detail",

  // Venue/Storage Owners
  MANAGE_STORAGE_OWNERS = "/manage-storage-owners",
  EDIT_STORAGE_OWNER = "/manage-storage-owners/edit",
  MANAGE_VENUE_OWNERS = "/manage-venue-owners",
  EDIT_VENUE_OWNER = "/manage-venue-owners/edit",
  // Booking Requests
  MANAGE_BOOKINGS = "/manage-booking-requests",
  ADD_BOOKING = "/manage-booking-requests/add",
  VIEW_BOOKING_DETAILS = "/manage-booking/detail/:id",

  // Loyalty Points
  MANAGE_LOYALTY_POINTS = "/manage-loyalty-points",
  LOYALTY_POINTS_DETAILS = "/manage-loyalty-points/details",


  // Categories
  MANAGE_CATEGORIES = "/manage-categories",
  MANAGE_SUBCATEGORY = "/manage-categories/subcategory/",
  CATEGORY_DETAILS = "/manage-categories/details/",
  // Payments
  MANAGE_PAYMENTS = "/manage-payments",

  // Sub Admins
  MANAGE_SUBADMIN = "/manage-subadmin",
  ADD_SUBADMIN = "/manage-subadmin/add",
  SUBADMIN_DETAIL = "/manage-subadmin/detail",
  MANAGE_ROLES = "/manage-subadmin/roles",
  ADD_ROLE = "/manage-subadmin/roles/add",
  ROLE_DETAIL = "/manage-subadmin/roles/detail",

  // Analytics
  REVENUE_ANALYTICS = "/revenue-analytics",

  // Support
  MANAGE_CUSTOMER_SUPPORT = "/manage-customer-support",

  // Notifications
  MANAGE_NOTIFICATIONS = "/manage-notifications",

  // Reviews
  MANAGE_REVIEWS = "/manage-reviews",

  // CMS
  MANAGE_CMS = "/manage-cms",

  //STORAGE
  MANAGE_STORAGE_CATEGORIES = "/manage-storage-categories",
  MANAGE_FACILITIES = "/manage-facilities",

  //RECOMMENDED
  MANAGE_RECOMMENDED_STORAGES = "/manage-recommended-storages",

  //DISCOUNT
  DISCOUNT_COUPON_MANAGEMENT = "/discount-coupon-management",
  ADD_DISCOUNT = "/discount-coupon-management/add",
  EDIT_DISCOUNT = "/discount-coupon-management/",
  DISCOUNT_DETAILS = "/discount-coupon-management/details",

  //BANNER
  MANAGE_BANNERS = "/manage-banners",
  ADD_BANNERS = "/manage-banners/add",
  EDIT_BANNERS = "/manage-banners/edit",
  BANNERS_DETAILS = "/manage-banners/details",

  //recommended
  RECOMMENDED_VENUE = "/manage-recommended-venue",
  ADD_RECOMMENDED_VENUE = "/manage-recommended-venue/add",
  RECOMMENDED_VENUE_DETAILS = "/manage-recommended-venue/details",

  //NEWS
  MANAGE_NEWS = "/manage-news",
  ADD_NEWS = "/manage-news/add",
  EDIT_NEWS = "/manage-news/edit",
  NEWS_DETAILS = "/manage-news/details",

  //Blog
  MANAGE_BLOGS = "/manage-blogs",
  ADD_BLOG = "/manage-blogs/add",
  EDIT_BLOG = "/manage-blogs/edit",
  BLog_DETAILS = "/manage-blogs/details",

  //AMENITIES
  MANAGE_AMENITIES = "/manage-amenities",
  ADD_AMENITIES = "/manage-amenities/add",
  AMENITIES_DETAILS = "/manage-amenities/details",

  //FAQ
  MANAGE_FAQ = "/manage-faq",

  //REFUNDS
  MANAGE_REFUNDS = "/manage-refunds",
  REFUND_DETAILS = "/manage-refunds/details",
}
